export default __webpack_public_path__ + "static/media/doctors-screenshot.4c31f018.png";